export default __webpack_public_path__ + "static/media/catspaw.1cc0d2d1.png";